import React, { FC, memo, MouseEventHandler } from 'react'
import { BottomSheet } from 'react-components'

import {
    Col,
    DatePickerIcon,
    GuestPickerIcon,
    Input,
    InputsContainer,
    LocationPickerIcon,
    ModalHeader,
    Row,
} from './styles'
import { useTranslation } from '../../../../../hooks/locale'
import { SubmitButton } from '../../../../common/controlled-searchbar/styles'
import { InputError } from '../../../../common/input-styles'
import Spinner from '../../../../common/spinner'

interface Props {
    isOpen: boolean
    onLocationPickerOpen: () => void
    onDatePickerOpen: () => void
    onGuestPickerOpen: () => void
    locationPickerLabel: string
    datePickerLabel: string
    guestPickerLabel: string
    locationPickerError?: string
    onClose: () => void
    onSubmit: MouseEventHandler<HTMLButtonElement>
    isSubmitting: boolean
}

const AllInputsModal: FC<Props> = ({
    isOpen,
    onLocationPickerOpen,
    onDatePickerOpen,
    onGuestPickerOpen,
    locationPickerLabel,
    datePickerLabel,
    guestPickerLabel,
    locationPickerError,
    onClose,
    onSubmit,
    isSubmitting,
}) => {
    const { t } = useTranslation()

    const header = <ModalHeader>{t('allInputsHeading')}</ModalHeader>

    const content = (
        <InputsContainer>
            <Row>
                <Col hasError={!!locationPickerError} onClick={onLocationPickerOpen} role="button">
                    <LocationPickerIcon alt={t('mapIconText')} />
                    <Input value={locationPickerLabel} />
                    {!!locationPickerError && <InputError>{locationPickerError}</InputError>}
                </Col>
            </Row>
            <Row>
                <Col onClick={onDatePickerOpen} role="button">
                    <DatePickerIcon alt={t('calendarIconText')} />
                    <Input value={datePickerLabel} />
                </Col>
                <Col onClick={onGuestPickerOpen} role="button">
                    <GuestPickerIcon alt={t('guestIconText')} />
                    <Input value={guestPickerLabel} />
                </Col>
            </Row>
        </InputsContainer>
    )

    const footer = (
        <SubmitButton onClick={onSubmit} disabled={isSubmitting}>
            {isSubmitting ? <Spinner /> : t('searchButtonText')}
        </SubmitButton>
    )

    return (
        <BottomSheet
            isOpen={isOpen}
            onClose={onClose}
            rootElementSelector="#__next"
            maxHeightRatio={0.7}
            borderRadius="24px"
            showSwipeIcon
            header={header}
            content={content}
            footer={footer}
            enableSwipeToClose
        />
    )
}

export default memo(AllInputsModal)
